import * as types from "../../../EarningsGroup/actions/companylevel/index";
export default function(state = [], action) {
  switch (action.type) {
    case types.ADD_EARNINGS_ALL_EARNING_GROUP_DROPDOWN_LIST:
      return action.payload.data;
    default:
      return state;
  }
}
